<template src="./index.html">
</template>
<script>
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				compstate: "show",
			};
		},
		props: {
			choosetitleindex: {
				type: String,
				default: ""
			},
			statedata: {
				type: Array,
				default: []
			},
			treedata: {
				type: Array,
				default: []
			},
			toseeUpdate:{
				type: Boolean,
				default: false
			}

		},
		created() {
			// this.statedata = this.statedata.reverse()
			
		},
		 watch: {
		    treedata: function() {
		      this.px();
		    },
		  },

		methods: {
			px(){
				this.statedata.sort(function(a,b){
					return a.createTime<b.createTime?1:-1
				})
				
			},
			forchoosetitle(item) {
				this.$emit("getchoosetitleindex", item)
			},
			changestate(e) {
				this.compstate = e
				this.$emit("changestate", e)
			}
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>
